<template>
  <div class="ko-footer">
    <div class="logo">
      <img src="https://static-s.theckb.com/BusinessMarket/icon/ckb_logox4.png" alt="">
    </div>
    <div class="company-info flex">
      <div class="company-info-content">
        <div class="compayn-info-item">
          <div class="title">회사명</div>
          <div class="text">스니프코리아 주식회사(SNIFF KOREA LIMITED)</div>
        </div>
        <div class="compayn-info-item">
          <div class="title">통신판매신고 번호</div>
          <div class="text">제2023-경기김포-2616호</div>
        </div>
      </div>
      <div class="company-info-content">
        <div class="compayn-info-item">
          <div class="title">사업자 등록 번호</div>
          <div class="text">708-81-02912</div>
        </div>
        <div class="compayn-info-item">
          <div class="title">사업장 주소</div>
          <div class="text">경기도 김포시 김포한강9로75번길 190, 7층 715호-브이3</div>
        </div>
      </div>
      <div class="company-info-content">
        <div class="compayn-info-item">
          <div class="title">대표자</div>
          <div class="text">WU YEBIAO</div>
        </div>
        <div class="compayn-info-item">
          <div class="title">이메일 주소</div>
          <div class="text">korea@theckb.com</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.ko-footer{
  width:1200px;
  padding:  32px 0 24px;
  margin:auto;
  .logo{
    img{
      width:156px;
    }
    padding-bottom:16px;
    margin-bottom:16px;
    border-bottom:1px solid rgba(255, 255, 255, 0.25);
  }
  .company-info{
    .company-info-content{
      flex:1;
      .compayn-info-item{
        margin-bottom:16px;
        .title{
          color:#fff;
          font-size: 12px;
          line-height: 20px;
          font-weight: 600;
        }
        .text{
          line-height: 20px;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.88);
        }
      }
    }
  }
}
</style>
